import { useMemo } from 'react';
import type {
  DataTableRenderCellParams,
  DataTableRowEventHandler,
  TableData
} from '@/components/custom/erp/data-table-v2';
import { TatToanHoaDonItem } from '@/types/schemas';

export interface UseTableDataReturn {
  tables: TableData[];
  handleRowClick: DataTableRowEventHandler;
}

export function useTableData(data: TatToanHoaDonItem[]): UseTableDataReturn {
  const tables = useMemo(() => {
    const tableData: TableData[] = [
      {
        name: '',
        columns: [
          {
            field: 'ma_don_vi',
            headerName: 'Đơn vị',
            width: 100,
            renderCell: (params: DataTableRenderCellParams) => params.row.ma_don_vi || ''
          },
          { field: 'ma_chung_tu', headerName: 'Mã chứng từ', width: 120 },
          { field: 'so_chung_tu', headerName: 'Số c/từ', width: 120 },
          { field: 'ngay_chung_tu', headerName: 'Ngày c/từ', width: 120 },
          { field: 'ma_khach_hang', headerName: 'Mã khách hàng', width: 130 },
          { field: 'ten_khach_hang', headerName: 'Tên khách hàng', width: 200 },
          { field: 'dien_giai', headerName: 'Diễn giải', width: 250 },
          { field: 'tai_khoan', headerName: 'Tài khoản', width: 100 },
          {
            field: 'tong_tien',
            headerName: 'Tổng tiền',
            width: 130,
            type: 'number',
            renderCell: (params: DataTableRenderCellParams) =>
              new Intl.NumberFormat('vi-VN').format(params.row.tong_tien || 0)
          },
          {
            field: 'da_thanh_toan',
            headerName: 'Đã thanh toán',
            width: 130,
            type: 'number',
            renderCell: (params: DataTableRenderCellParams) =>
              new Intl.NumberFormat('vi-VN').format(params.row.da_thanh_toan || 0)
          },
          {
            field: 'con_lai',
            headerName: 'Còn lại',
            width: 130,
            type: 'number',
            renderCell: (params: DataTableRenderCellParams) =>
              new Intl.NumberFormat('vi-VN').format(params.row.con_lai || 0)
          },
          {
            field: 'tien_tat_toan',
            headerName: 'Tiền tất toán',
            width: 130,
            type: 'number',
            renderCell: (params: DataTableRenderCellParams) =>
              new Intl.NumberFormat('vi-VN').format(params.row.tien_tat_toan || 0)
          }
        ],
        rows: data.map(item => ({
          id: item.id,
          ma_don_vi: item.ma_don_vi,
          ma_chung_tu: item.ma_chung_tu,
          so_chung_tu: item.so_chung_tu,
          ngay_chung_tu: item.ngay_chung_tu,
          ma_khach_hang: item.ma_khach_hang,
          ten_khach_hang: item.ten_khach_hang,
          dien_giai: item.dien_giai,
          tai_khoan: item.tai_khoan,
          tong_tien: item.tong_tien,
          da_thanh_toan: item.da_thanh_toan,
          con_lai: item.con_lai,
          tien_tat_toan: item.tien_tat_toan
        }))
      }
    ];

    return tableData;
  }, [data]);

  const handleRowClick: DataTableRowEventHandler = () => {};

  return {
    tables,
    handleRowClick
  };
}
